// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3F8er","col":"styles_col__3L6VM","actions":"styles_actions__2uCjV","conflict":"styles_conflict__2m7-z"};